// Rules of the "Ajouter à un débrief" menu of the call modal.

// Debrief dates reach the front as ISO strings, or as Firestore timestamps
// ({seconds} / {_seconds}) depending on the serializer. Returns seconds, or 0.
export const toDebriefTs = (date) => {
  if (!date) return 0;
  if (date.seconds) return date.seconds;
  if (date._seconds) return date._seconds;
  const parsed = new Date(date).getTime();
  return Number.isNaN(parsed) ? 0 : parsed / 1000;
};

// The date a debrief is about: when it is planned, else the period it covers.
// The creation `date` is only a last resort.
export const getDebriefReferenceTs = (debrief) =>
  toDebriefTs(debrief?.scheduled_date) ||
  toDebriefTs(debrief?.period_end) ||
  toDebriefTs(debrief?.period_start) ||
  toDebriefTs(debrief?.date);

// Completed, deleted and archived debriefs can no longer receive calls.
export const isDebriefOpenForCalls = (debrief) =>
  !!debrief &&
  debrief.status !== "completed" &&
  debrief.status !== "deleted" &&
  debrief.archived !== true;

export const isCallInDebrief = (debrief, call_id) =>
  !!call_id && Array.isArray(debrief?.call_ids) && debrief.call_ids.includes(call_id);

/**
 * Debriefs to offer for a call: open ones only, restricted to the call's operator
 * unless `show_all_operators`, filtered by operator name, most relevant first.
 */
export const selectAddableDebriefs = ({
  debriefs,
  operator_id,
  show_all_operators = false,
  search = "",
}) => {
  const query = search.trim().toLowerCase();

  return (debriefs || [])
    .filter(isDebriefOpenForCalls)
    .filter((debrief) => show_all_operators || !operator_id || debrief.operator_id === operator_id)
    .filter((debrief) => !query || debrief.operator_name?.toLowerCase().includes(query))
    .sort((a, b) => getDebriefReferenceTs(b) - getDebriefReferenceTs(a));
};

/**
 * `/admin/operators` returns a map keyed by operator id. The create-debrief form
 * wants an array of active operators, but the call's own operator must stay
 * selectable even if it has since been deactivated.
 */
export const buildDebriefOperators = (operator_map, keep_operator_id) =>
  Object.keys(operator_map || {})
    .filter((operator_id) => operator_id !== "no_operator_id")
    .map((operator_id) => ({
      ...operator_map[operator_id],
      id: operator_map[operator_id]?.id || operator_id,
    }))
    .filter((operator) => operator.is_active !== false || operator.id === keep_operator_id);
